// extracted by mini-css-extract-plugin
export default {"title":"t_-z","warning":"u_-z","sizeOptionsLegendText":"v_-z"};